import { gql } from 'apollo-angular'

export default gql`
  mutation delete_schedule_by_pk($id: Int!) {
    delete_schedule(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`
